import React from 'react';
import { DeactivateAccountContainer, CancelInfoText } from './index.styles';

const BreachDeactivateInfo = () => (
  <DeactivateAccountContainer>
    <CancelInfoText>
      Remember – your account will be deactivated when your subscription ends if you do not choose an option.
    </CancelInfoText>
  </DeactivateAccountContainer>
);

export default BreachDeactivateInfo;
